
<script>
  import {createEventDispatcher} from "svelte";
  import { ShowTowerHamletQuestion } from "./store.js";
  import Modal from "../HTMLElements/Modal.svelte";
  import Field from "../FormField.svelte";
  import Radio from "../HTMLElements/RadioInput.svelte";
  import CheckBox from "../HTMLElements/CheckBoxInput.svelte";
  import wrappedFetch from  '../../wrappedFetch.js';
  export let showTowerHamletQuestion = false;
 // export let childId;
  export let applicationId;
  export let answerDetails;
  let NFER,TeacherAssessment; //,EldestChild,EldestGenderlabel;
  let err='';
  let isUpdating = false;

    
  if(answerDetails)
  {    
      answerDetails.split(';').forEach((list,key) => {         
        // if(key == 0)
        //  EldestChild =  list.split('=')[1] == 'Y' ? true : false;
        //if(key == 1)
        //      EldestGenderlabel =list.split('=')[1] == 'Y' ? true : false;
        if(key == 2)
        {
            if(list.split('=')[0] =='NFER Test band')  
                    NFER = list.split('=')[1];
                     else
                TeacherAssessment = list.split('=')[1];
        }
         if(key == 3)
              TeacherAssessment = list.split('=')[1];
          
      });
  }
   const dispatch = new createEventDispatcher();
 
   export let genderDetail;
  let radioItems = [
    { value: "A", TextValue: "A" },
    { value: "B", TextValue: "B"},
    { value: "C", TextValue: "C" },
    { value: "D", TextValue: "D" }
  ];
    export let radioParams = { item: radioItems, required: false};

    const UpdateApplicationAnswers = async() =>{      
         err ='';  
         showTowerHamletQuestion = false;     
        let answers ={applicationId: parseInt(applicationId) ,NFER : NFER,TeacherAssessment : TeacherAssessment,
  //       EldestChild : EldestChild ?"Y":"N",
  //        EldestGenderlabel :EldestGenderlabel?"Y":"N",
          GenderDetails : genderDetail
          }
   isUpdating = true;      
  await wrappedFetch(`/preferences/UpdateApplicationAnswers`, {
      method: "post",
       headers: {
          'Content-Type': 'application/json'
        },
      body: JSON.stringify(answers)
    })
      .then(response => response.json())
      .then(response => {       
        if(response == 1)
        {          
           ShowTowerHamletQuestion.set(false);
           dispatch('success');  
           isUpdating = false;        
           
        }
        else
        {
        err = 'Something went wrong.';
        isUpdating = false;
        return false;

        }
      });
       
    }
</script>
<Modal bind:showModal={showTowerHamletQuestion} on:closed={UpdateApplicationAnswers} allowClose={false}>       
  <div class="step-3-shows">
    <div class="field" >
      <h1 class="title is-3">Enter the following information</h1>
      <!-- <span name="infoIcon" class="icon helpicon"  on:click={() => { dispatch('showContextualHelpModal')}}>
      <span class="fas fa-question-circle"></span>
      </span>-->
    </div>
    <div class="field">
        Children attending a Tower Hamlets primary school or a school outside of Tower Hamlets must enter their Teacher assessment grade, either A,B,C or D with D being the highest Band.<br/>
        Please select Band A, B, C or D  below.
    </div>
    <Field label="Band">
      <span slot="inputField">
        <Radio label="Band"
            bind:group={TeacherAssessment}
            {...radioParams}
        />
      </span>
    </Field>
    <!--CheckBox
      label="Tick if child is your eldest child"
      bind:checked={EldestChild} 
    />
    <CheckBox
      label="Tick if child is your eldest {genderDetail}"
      bind:checked={EldestGenderlabel}
    /-->
    {#if err!=''}<div class="field"><p class="help is-danger">{err}</p></div>{/if}
  </div>  
  <footer class="modal-card-foot buttons is-right" slot="footer">  
      <a href="#" on:click|preventDefault={UpdateApplicationAnswers}    class="button {isUpdating ? 'is-loading' : ''}" style="margin-right:10px;" >Continue</a>       
  </footer>
          
</Modal>